/**
 * Legal Guarantee Modal
 *
 * Listens for a custom event `legal-guarantee:open` to show the modal.
 * Any element with [data-open-guarantee-modal] will dispatch this event on click.
 * On checkout pages (window.Shopify.Checkout), injects the trigger text into [role="list"].
 *
 * CHECKOUT USAGE:
 * Add this script to Shopify Admin → Settings → Checkout → Additional scripts:
 * <script src="https://cdn.shopify.com/s/files/1/0640/7877/4385/files/legal-guarantee-modal.js" defer></script>
 * (Upload this file via Settings → Files, then use the CDN URL)
 */
(function () {
  'use strict';

  // --- Determine guarantee image URL based on locale ---
  var lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var images = {
    en: 'https://cdn.shopify.com/s/files/1/0640/7877/4385/files/ENN_page1.webp?v=1787111188',
    it: 'https://cdn.shopify.com/s/files/1/0640/7877/4385/files/ITN_page1.webp?v=1787111188',
    es: 'https://cdn.shopify.com/s/files/1/0640/7877/4385/files/ESN_page1.webp?v=1787111188',
    de: 'https://cdn.shopify.com/s/files/1/0640/7877/4385/files/DEN_page1.webp?v=1787111188'
  };
  var imgSrc = images[lang] || images.en;

  // --- Create modal DOM ---
  var modal = document.createElement('div');
  modal.id = 'legal-guarantee-modal';
  modal.className = 'lg-modal';
  modal.setAttribute('aria-hidden', 'true');
  modal.innerHTML =
    '<div class="lg-modal__backdrop"></div>' +
    '<div class="lg-modal__content">' +
      '<button class="lg-modal__close" type="button" aria-label="Close">&times;</button>' +
      '<img src="' + imgSrc + '" alt="Legal guarantee rights" loading="lazy">' +
    '</div>';

  // --- Inject styles ---
  var style = document.createElement('style');
  style.textContent =
    '.lg-modal{display:none;position:fixed;inset:0;z-index:999999;align-items:center;justify-content:center}' +
    '.lg-modal.is-open{display:flex}' +
    '.lg-modal__backdrop{position:absolute;inset:0;background:rgba(0,0,0,.6)}' +
    '.lg-modal__content{position:relative;z-index:1;max-width:90vw;max-height:90vh;overflow:auto;background:#fff;border-radius:8px;scrollbar-width:none}' +
    '.lg-modal__content::-webkit-scrollbar{display:none}' +
    '.lg-modal__content img{display:block;width:100%;height:auto;max-width:600px}' +
    '.lg-modal__close{position:absolute;top:12px;right:12px;z-index:2;width:36px;height:36px;border:none;border-radius:50%;background:rgba(255,255,255,.9);color:#121417;font-size:20px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 8px rgba(0,0,0,.15)}';
  document.head.appendChild(style);

  // --- Open / Close logic ---
  function openModal() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Close on backdrop / close button
  modal.querySelector('.lg-modal__backdrop').addEventListener('click', closeModal);
  modal.querySelector('.lg-modal__close').addEventListener('click', closeModal);

  // ESC key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  // --- Listen for custom event ---
  document.addEventListener('legal-guarantee:open', openModal);

  // --- Bind all [data-open-guarantee-modal] elements ---
  function bindTriggers() {
    document.querySelectorAll('[data-open-guarantee-modal]').forEach(function (el) {
      if (el._lgBound) return;
      el._lgBound = true;
      el.addEventListener('click', function (e) {
        e.preventDefault();
        document.dispatchEvent(new CustomEvent('legal-guarantee:open'));
      });
    });
  }

  // --- Checkout page injection ---
  function injectCheckoutTrigger() {
    var isCheckout = !!(window.Shopify && window.Shopify.Checkout) || /\/checkouts\//.test(window.location.pathname);
    if (!isCheckout) return;

    var target = document.getElementById('checkout-pay-button-section');
    if (!target) return;

    // Avoid duplicate injection
    if (target.parentNode.querySelector('.lg-checkout-trigger')) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'lg-checkout-trigger';
    wrapper.style.cssText = 'text-align:center;margin-top:12px;';
    var link = document.createElement('a');
    link.href = '#';
    link.textContent = 'Your legal guarantee rights';
    link.setAttribute('data-open-guarantee-modal', '');
    link.style.cssText = 'color:#121417;font-family:"SF Pro",sans-serif;font-size:14px;font-weight:590;text-decoration:none;cursor:pointer;';
    link.addEventListener('mouseenter', function () { link.style.textDecoration = 'underline'; });
    link.addEventListener('mouseleave', function () { link.style.textDecoration = 'none'; });
    wrapper.appendChild(link);
    target.insertAdjacentElement('afterend', wrapper);

    bindTriggers();
  }

  // --- Init ---
  function init() {
    document.body.appendChild(modal);
    bindTriggers();
    injectCheckoutTrigger();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(() => {
      init();
    }, 100)
  }
})();
